import React from "react";
import PageShell from "@/components/PageShell";

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2
      className="text-[#FFC800] text-xs tracking-[0.3em] uppercase font-bold mb-3"
      style={{ fontFamily: '"JetBrains Mono", monospace' }}
    >
      {title}
    </h2>
    <div
      className="text-neutral-300 text-sm leading-relaxed space-y-3"
      style={{ fontFamily: '"Manrope", sans-serif' }}
    >
      {children}
    </div>
  </section>
);

export const Terms = () => {
  return (
    <PageShell>
      <article
        className="max-w-3xl mx-auto px-6 py-10 lg:py-14"
        data-testid="terms-page"
      >
        <div
          className="text-[10px] text-neutral-500 tracking-[0.3em] uppercase mb-2"
          style={{ fontFamily: '"JetBrains Mono", monospace' }}
        >
          Legal
        </div>
        <h1
          className="text-white text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-none mb-2"
          style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
        >
          Terms of <span className="text-[#FFC800]">Service</span>
        </h1>
        <div
          className="text-[10px] text-neutral-500 tracking-[0.2em] uppercase mb-10"
          style={{ fontFamily: '"JetBrains Mono", monospace' }}
        >
          Last updated: 30 April 2026
        </div>

        <Section title="Acceptance of these terms">
          <p>
            By using randomsixsiege.co.uk (the "Site") you agree to these Terms of
            Service. If you do not agree, please do not use the Site.
          </p>
        </Section>

        <Section title="Fan project — not affiliated with Ubisoft">
          <p>
            This Site is an unofficial, free, non-commercial fan tool for the video game
            Tom Clancy's Rainbow Six Siege. All operator names, logos, and game-related
            trademarks belong to their respective owners (Ubisoft Entertainment SA). We
            are not endorsed by or affiliated with Ubisoft. If a rights-holder wishes any
            content removed, contact us and we will comply promptly.
          </p>
        </Section>

        <Section title="No accounts, no payments">
          <p>
            The Site does not require user registration. There are currently no paid
            features, and we have no plans to introduce any payment features any time
            soon. If we ever add them, separate terms will apply at the point of
            purchase.
          </p>
        </Section>

        <Section title="Acceptable use">
          <p>You agree not to:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Attempt to interfere with or disrupt the Site (e.g., bot abuse, scraping at scale, DDoS).</li>
            <li>Reverse-engineer, scrape, or republish substantial portions of the Site without permission.</li>
            <li>Use the Site to harass, defame, or violate the rights of any third party.</li>
          </ul>
        </Section>

        <Section title="No warranty">
          <p>
            The Site is provided "as is" and "as available", without warranty of any
            kind. We do not guarantee that operator data, weapon names, or any other
            information shown is accurate, current, or fit for any purpose. Use at your
            own risk.
          </p>
        </Section>

        <Section title="Limitation of liability">
          <p>
            To the fullest extent permitted by law, in no event will we be liable for any
            indirect, incidental, special, consequential, or punitive damages arising out
            of or relating to your use of the Site.
          </p>
        </Section>

        <Section title="Changes to the Site or these terms">
          <p>
            We may modify, suspend, or discontinue any part of the Site at any time
            without notice. We may also update these Terms; the "last updated" date at
            the top will reflect changes. Continued use after changes means you accept
            the new Terms.
          </p>
        </Section>

        <Section title="Governing law">
          <p>
            These Terms are governed by the laws of England and Wales. Any dispute will
            be handled by the courts of England and Wales, unless local consumer
            protection laws give you stronger rights.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Questions or copyright takedown notices? Email{" "}
            <span className="text-[#FFC800]">contact@randomsixsiege.co.uk</span>.
          </p>
        </Section>
      </article>
    </PageShell>
  );
};

export default Terms;
